import * as React from "react";
import { useState, useContext, createContext, useEffect } from "react";
import VersionedDocumentField from "~common/components/fields/versioned-document-field-fc";
import {cloneDeep} from 'lodash'
import {ListContext} from '~common/components/fields/versioned-document-list-fc';

export const ItemContext = createContext();

interface VersionedDocumentListItemProps {
    idx: number;
    fieldDefinition: any;
    readOnlyOverride?: boolean;
}

export const VersionedDocumentListItem: React.FC<VersionedDocumentListItemProps> = ({
    idx,
    fieldDefinition,
    readOnlyOverride,
  }) => {
    
    const [listValue, setListValue] = useContext(ListContext); 
    
    // If listValue is null, this would error and cause the UI to go blank so check first
    // const [fieldValue, setFieldValue] = useState(listValue[idx])
    var lv:any = null
    if (listValue && listValue.length > 0) {
        lv = listValue[idx]
    }
    const [fieldValue, setFieldValue] = useState(lv)

    const onDelete = () => {
        let list = cloneDeep(listValue)
        list.splice(idx, 1);
        setListValue(list)
    }

    useEffect(() => {
        if (listValue && listValue[idx]) {
            var lv = listValue
            var fv = lv[idx]
            setFieldValue(fv);
        }
    }, [listValue])

    useEffect(() => {
        if (fieldValue && listValue) {
            var lv = cloneDeep(listValue)
            lv[idx] = fieldValue
            setListValue(lv);
        }
    }, [fieldValue])

    return (
        <ItemContext.Provider value={[fieldValue, setFieldValue]}>
            <VersionedDocumentField
                fieldDefinition={fieldDefinition}
                readOnlyOverride={readOnlyOverride}
                contextType={"listItem"}
                onItemDelete={onDelete}
            />
        </ItemContext.Provider>
        
    );
  };

  export default VersionedDocumentListItem;